<template>
    <div class="mb-xl-0 pb-5" :style="`background-color: #f9f9f9;`">
        <div ref="observerTimeDesk"></div>
        <div class="container pt-4 conheca-time mb-3 mb-xl-0" v-if="users">
            <div class="row">
                <div class="col-12">
                    <h1 class="font-glacial-bold text-left text-lowercase text-xl-left text-center mb-md-5 font-size-know-team mt-md-3">{{data.title}}</h1>
                </div>
            </div>
            <transition enter-active-class="animated fadeInUp">
            <div class="row mt-4 mb-0 pb-0" >
                <b-link router-tag="a" :to="`/blog/autor/${removeAcento(d.name)}`" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 pb-2 clickable" v-for="(d, i) in users" :key="i" v-if="d.slug != 'admin'">
                    <div class="border-transparent border-radius-0 pr-xl-0 pr-md-3">
                        <div class="card-body card text-white card-time p-0 border-0 border-radius-0 height-mobile" :style="'background-image: url(' + authorAvatar(d) + ')'" @touchstart="show = i" @touchend="show = -1" @mouseover="show = i" @mouseleave="show = -1">
                            <div class="row no-gutters h-100 w-100 align-items-center" v-if="show == i">
                                <div class="col-12 align-self-center text-center pt-3 mt-5">
                                    <h2 class="font-glacial-bold">
                                        {{d.name}}
                                    </h2>
                                    <p class="font-glacial-regular mb-4 pb-4">
                                        {{d.description}}
                                    </p>
                                </div>
                            </div> 
                        </div>
                    </div>
                </b-link>                
            </div>
            </transition>
        </div>

        <!-- <div class="d-flex d-xl-flex justify-content-center pb-0 pb-sm-3 pt-4 pt-xl-0 pb-0" v-if="$route.name == 'Home'">
            <b-button variant="ver-todos" class="col-xl-2 mb-3 mt-xl-1 mt-3 btn-opacidade" to="/bauhaus"></b-button>
        </div> 

        <div class="slider-fullwidth-mobile" v-else-if="users.length < data.time.length">
            <div class="row d-flex justify-content-center mt-3">
                <b-button variant="ver-mais" @click="postsSliced" :disabled="loading" class="btn-opacidade"></b-button>
            </div>   
        </div> -->
        
    </div>
</template>
<script>
import observer from 'intersection-observer';

export default {
    props:{
        data: null,
    },

    data(){
        return{
            loading: false,
            users: null,

            show: -1,
        }
    },

    created(){
        this.loadUsers()
    },

    mounted(){
        var observerDesk = new IntersectionObserver((entries) => {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) {
                return;
            }
            this.showObserverDesk = true
            observerDesk.unobserve(this.$refs.observerTimeDesk)
        });
        observerDesk.observe(this.$refs.observerTimeDesk);

        observer.POLL_INTERVAL = 100;
    },

    methods:{
        removeAcento(text){
            text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
            text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
            text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
            text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
            text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
            text = text.replace(new RegExp('[Ç]','gi'), 'c');
            text = text.replace(' ', '-');
            
            return text.toLowerCase();	
        },

        routeTo(obj){
            console.log(obj)
            this.$router.push(obj)

        },

        async loadUsers(){

            this.loading = true

            var url = window.SETTINGS.API_BASE_PATH + "users?_view&role=author"

            var response = await axios.get(url)
                
            this.users = response.data

            this.loading = false
        },

        authorAvatar(d){
            if(d.mpp_avatar && d.mpp_avatar.full){
                return d.mpp_avatar.full
            } else {
                return '/wp-content/themes/rhiza/dist/assets/blank-profile-picture.png'
            }
        }
    },
}
</script>
<style scope>
.card-time {
    max-height: 375px
}
</style>


// WEBPACK FOOTER //
// src/components/widgets/autores.vue